import { useEffect, useState } from "react";
import { QuerySummary as HeadlessQuerySummary } from "@coveo/headless";
import { PageType } from "components/coveo-headless/types/coveo-headless-types";

type TotalResultsProps = {
	controller: HeadlessQuerySummary;
	pageType: string;
	showInFilters: boolean;
	totalResultsDescription: string;
};

const TotalResults = ({
	controller,
	pageType,
	showInFilters,
	totalResultsDescription
}: TotalResultsProps) => {
	const isGlobalSearch =
		pageType === PageType.Search ? "searchGlobalCountrySelector" in window : false;

	const [state, setState] = useState(controller.state);
	useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

	const { total, hasQuery, query } = state;

	const resultsCount = `${total} ${totalResultsDescription}`;

	return (
		<>
			{(pageType === PageType.Insights || pageType === PageType.MyDimensional) &&
				!showInFilters && (
					<div className="coveo-headless-content-count">
						<span className="t-heading-md tc-cool-gray-02">{resultsCount}</span>
					</div>
				)}
			{pageType === PageType.MyDimensional && showInFilters && <>{`Done (${total})`}</>}
			{pageType === PageType.Search && !showInFilters && (
				<div>
					<h2 className="h2-italic-left-white">{`Showing ${total} ${
						isGlobalSearch ? "global" : ""
					} results ${hasQuery ? `for "${query}"` : ""}`}</h2>
				</div>
			)}
		</>
	);
};

export default TotalResults;
